<template>
    <div class="appteamdetail">
      <div class="container row">
        <h3 v-if="post_data!=null">{{post_data.member_full_name}}</h3>
        <h5 v-if="post_data!=null">{{post_data.member_position}}</h5>
        <div class="member_detail" v-if="post_data!=null" v-html="post_data.member_description"></div>
        <div class="member_links" v-if="post_data!=null">
          <div class="half"><a href="#">Blog</a></div>
          <div class="half" v-if="post_data.member_email!=''"><a href="post_data.member_email">Email</a></div>
          <div class="half" v-if="post_data.member_twitter!=''"><a href="post_data.member_twitter">Twitter</a></div>
          <div class="half" v-if="post_data.member_linkedin!=''"><a href="post_data.member_linkedin">LinkedIn</a></div>
        </div>
        <div v-if="post_data!=null" class="back_button"><router-link to="/team">Back</router-link></div>
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      wpData: wpData,
      post_data: null
    }
  },
  mounted() {
    fetch(`${this.wpData.rest_url}/wp/v2/pagedata?page_title=Our Team`)
      .then(res => res.json())
      .then(data => {
        this.page_data = data;
        fetch(`${this.wpData.rest_url}/wp/v2/acfdata?post_id=${data.ID}&field_name=team_member`)
          .then(res => res.json())
          .then(data1 => {
            this.post_data = data1[this.$route.params.id];
            console.log(this.post_data);
          });
      });
  },
  watch: {
    '$route' (to, from) {
      this.$router.go(to.path);
    }
  },
  methods: {
    gotoMenuPage: function(event){
      alert("Event1");
    }
  }
}
</script>

<style>
.appteamdetail {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 100px);
  padding: 50px 0;
  background: #fff;
  color: #172c62;
}
.appteamdetail .container{
  opacity: 0;
  animation-duration: 2s;
  animation-name: fade;
  animation-fill-mode: forwards;
  margin: auto;
}
.appteamdetail h3{
  font-size: 26px;
  text-align: left;
  width: 100%;
}
.appteamdetail h5{
  padding: 0;
  font-size: 15px;
  text-align: left;
  width: 100%;
  margin-bottom: 30px;
}
.member_detail{
  color: #000;
  text-align: left;
}
.member_links{
  width: 90%;
  margin: 20px auto 0;
  display: flex;
  flex-wrap: wrap;
}
.member_links .half{
  width: 50%;
}
.member_links a{
  color: #172c62;
  font-size: 24px;
}
.back_button{
  width: 80%;
  height: 40px;
  margin: 30px auto;
  display: flex;
  border: 1px solid #172c62;
  justify-content: center;
  align-items: center;
}
.back_button a{
  color: #172c62;
  font-size: 21px;
  text-decoration: none;
}
@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AppTeamDetail.vue